import FuseAnimate from '@fuse/core/FuseAnimate';
import React from 'react';
import LoginBg from '../images/login-bg.png';
import logoGif from '../images/01-05.png';

export default class ErrorHandling extends React.Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError(error) {
		return { hasError: true };
	}

	componentDidCatch(error, info) {
		setTimeout(function () {
			window.location.replace('/dashboard');
		}, 5000);
	}

	componentDidMount() {
		// document.body.style.backgroundImage = `url(${LoginBg})`;
		document.body.style.backgroundSize = 'cover';
	}

	render() {
		if (this.state.hasError) {
			return (
				<div
					className="flex flex-col flex-grow-0 items-center text-white p-16 text-center md:p-128 sm:p-16 md:items-center md:flex-shrink-0 md:flex-1 md:text-left gap-12"
					style={{ marginTop: 70 }}
				>
					<FuseAnimate
						animation={{
							scale: [1, 0.3],
							opacity: [1, 0]
						}}
						duration={1000}
						easing={[0.25, 0.46, 0.45, 0.94]}
					>
						<div>
							<img src={icon} style={{ width: 400, marginLeft: '-6%' }} />
						</div>
					</FuseAnimate>
					<FuseAnimate animation="transition.slideUpIn" style={{ marginTop: 200, fontWeight: '800px' }}>
						<h1	>Just a moment — loading things for you…</h1>
					</FuseAnimate>
				</div>
			);
		}
		return this.props.children;
	}
}
